import React, { useState ,useEffect} from 'react'
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader';
import { getLeadDetail, getTutorRegistrationDetail, updateTutorRegistration } from '../../components/services';
import { TOAST_CONFIG } from '../../config/constants';
import { getDate } from '../../helpers/dateHelper';
import UpdateStatus from './components/UpdateStatus';
// import AddEnquiryModal from './AddEnquiryModal';

export default function TutorRegInfo({viewItem,setViewItem,setShowUpdateModal,setShowCallModal}) {

    const [data,setData] = useState({})
    const [loading,setLoading] = useState(true)
    const [updateData,setUpdateData] = useState(false)
    const [showModal,setShowModal] = useState(false)
    const authInfo = useSelector(state=>state.auth)


      useEffect(() => {
        const getInfo = async()=>
        {
            try {
                setLoading(true)
                let res = await getTutorRegistrationDetail(viewItem._id)
                setData(res)
                setLoading(false)
                return true;
            } catch (error) {
                console.log(error)
                toast.error('error',TOAST_CONFIG)
                setLoading(false)
                return false;
            }
        }
        getInfo()
      }, [viewItem])
      


  return (<div className='loader-parent'>
      { !loading ? <>
      {/* {updateData ? <AddEnquiryModal setModal={setUpdateData} setViewItem={setViewItem} updateId={updateData._id} setEnquiryData={setEnquiryData}/> : null} */}
    <div className="pending-info-container">
        <div className="pending-info-content">
            <div className="pending-info-header">
                <div>
                    <p className="r-text m-weight f-op caps">{data.fullName} {data.alreadyRegistered ? <span className='primary-badge'>Already Registered</span> : ''}</p>
                    <p className="xxxs-text m-weight h-op caps">{getDate(data.createdAt)}</p>
                </div>
                <div className="pending-info-btn-container">
                    <button className="xs-delete-btn" onClick={()=>setShowCallModal(data._id)}>Add Call</button>
                    <button className="xs-delete-btn" onClick={()=>setShowUpdateModal(data._id)}>Update Status</button>
                    <button className="xs-delete-btn" onClick={()=>setUpdateData(data)} disabled={data.alreadyRegistered ? true : false}>Add Tutor</button>
                </div>
            </div>
            <div className="pending-inner-content">
                <div className="pending-info-grid">

                    <div>
                        <p className="xxs-text h-op m-weight">Mobile {data.mobileVerified === true ? <span className='primary-badge'>Verified</span> : null}</p>
                        <p className="xs-text f-op m-weight">{data.mobile}</p>
                    </div>

                    <div>
                        <p className="xxs-text h-op m-weight">Email</p>
                        <p className="xs-text f-op m-weight">{data.email}</p>
                    </div>

                    <div>
                        <p className="xxs-text h-op m-weight">City</p>
                        <p className="xs-text f-op m-weight caps">{data.city.cityName}</p>
                    </div>
                    <div>
                        <p className="xxs-text h-op m-weight">Locality</p>
                        <p className="xs-text f-op m-weight caps">{data.locality}</p>
                    </div>
                    
                    <div>
                        <p className="xxs-text h-op m-weight">Qualification</p>
                        <p className="xs-text f-op m-weight caps">{data.qualification}</p>
                    </div>

                    <div>
                        <p className="xxs-text h-op m-weight">Experience</p>
                        <p className="xs-text f-op m-weight caps">{data.experience} Yrs</p>
                    </div>

                    <div>
                        <p className="xxs-text h-op m-weight">Profession</p>
                        <p className="xs-text f-op m-weight caps">{data.profession ? data.profession : 'Not Available'}</p>
                    </div>

                    <div>
                        <p className="xxs-text h-op m-weight">Classmode</p>
                        <p className="xs-text f-op m-weight caps">{data.classMode ? data.classMode : 'Not Available'}</p>
                    </div>
                    <div>
                        <p className="xxs-text h-op m-weight">Status</p>
                        <p className="xs-text f-op m-weight caps">{data.status === 0 ? 'Open' : data.status === 1 ? 'Converted' : 'Cancelled'}</p>
                    </div>
                    <div>
                        <p className="xxs-text h-op m-weight">Reason</p>
                        <p className="xs-text f-op m-weight caps">{data.reason ? data.reason : 'Not Available'}</p>
                    </div>
                    <div>
                        <p className="xxs-text h-op m-weight">Reason Description</p>
                        <p className="xs-text f-op m-weight caps">{data.reasonDescription ? data.reasonDescription : 'Not Available'}</p>
                    </div>
                </div>
            </div>
        </div>
        <div className="pending-info-content mt-2">
            <div className="call-log-container">
                {
                    data?.callLogs && data.callLogs.map((item,index)=>
                    {
                        return <CallLogItem item={item}/>
                    })
                }
            </div>
            </div>
    </div>
    </> : <Loader/> } </div>
  )
}


const CallLogItem = ({item})=>
{
    return <div className='call-log-item'>
        <div className='call-log-name-container'>
            <p className='call-log-name'>A</p>
        </div>
        <div>
            {/* <p className='xs-text'>{data.employeeId.}</p> */}

        </div>
    </div>
}